module.exports = __webpack_public_path__ + "static/media/LandingPageLogo2.c0505ab1.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/LandingPageLogo2.png
// module id = 1053
// module chunks = 0